import L from 'leaflet';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';

export function createSvgMarkerIcon(colorHex = '#2B66B5', size = [25, 41]) {
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" width="${size[0]}" height="${size[1]}" viewBox="0 0 25 41">
      <path d="M12.5 0C6.4 0 1.2 5.2 1.2 11.6c0 8.2 10.9 20.9 10.9 20.9s10.9-12.7 10.9-20.9C23.8 5.2 18.6 0 12.5 0z" fill="${colorHex}" stroke="#000" stroke-opacity="0.15"/>
      <circle cx="12.5" cy="11.6" r="4.2" fill="#fff" fill-opacity="0.85" />
    </svg>`;
  const url = "data:image/svg+xml;charset=utf-8," + encodeURIComponent(svg);
  return new L.Icon({
    iconUrl: url,
    iconSize: size,
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowUrl: markerShadow,
    shadowSize: [41, 41],
    shadowAnchor: [12, 41]
  });
}
